import {
  CareerSiteFiltersOption,
  CareerSiteSettings,
} from 'api-clients/monolith';
import React from 'react';

import { Filters, FiltersSkeleton } from 'components/filters/index';
import { useJobs } from 'hooks/v2/useJobs';

import { JobsSection, JobsSectionSkeleton } from './jobs-section/index';
import { MobileFiltersDrawer } from './mobile-filters-drawer';

export const HOME_JOB_PER_PAGE = 3;

interface HomeMainProps {
  brandSetting: CareerSiteSettings;
  filterOptions?: {
    jobTypes: CareerSiteFiltersOption[];
    jobHours: CareerSiteFiltersOption[];
    countries: CareerSiteFiltersOption[];
    states: CareerSiteFiltersOption[];
    cities: CareerSiteFiltersOption[];
    category: CareerSiteFiltersOption[];
    position: CareerSiteFiltersOption[];
    locationName: CareerSiteFiltersOption[];
  };
}

export function HomeMain({ brandSetting, filterOptions }: HomeMainProps) {
  const { jobs, paginationData, isCurrentLocation, currentCity } = useJobs();

  return (
    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[300px_1fr] lg:gap-8">
      <div className="hidden lg:flex lg:flex-col lg:gap-6">
        <Filters brandSetting={brandSetting} filterOptions={filterOptions} />
      </div>

      <div className="flex flex-col gap-4">
        <JobsSection
          jobs={jobs}
          paginationData={paginationData}
          isCurrentLocation={isCurrentLocation}
          currentCity={currentCity}
          brandSetting={brandSetting}
          mobileFiltersDrawer={
            <MobileFiltersDrawer
              brandSetting={brandSetting}
              filterOptions={filterOptions}
            />
          }
        />
      </div>
    </div>
  );
}

HomeMain.Skeleton = function HomeMainSkeleton() {
  return (
    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[300px_1fr] lg:gap-8">
      <div className="hidden lg:flex lg:flex-col lg:gap-6">
        <FiltersSkeleton />
      </div>

      <div className="flex flex-col gap-4">
        <JobsSectionSkeleton />
      </div>
    </div>
  );
};
